import { Document } from './../../model/document.model';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-editor-dc',
  templateUrl: './editor-dc.component.html',
  styleUrls: ['./editor-dc.component.css']
})
export class EditorDcComponent implements OnInit {
  @Input() document: Document;

  constructor() { }

  ngOnInit() {
  }

}
